import * as THREE from 'three'

import Debug from './Utils/Debug.js'
import Sizes from './Utils/Sizes.js'
import Time from './Utils/Time.js'
import Camera from './Camera.js'
import Renderer from './Renderer.js'
import World from './World/World.js'
import Resources from './Utils/Resources.js'
import Functions from './World/Functions.js'
import sources from './sources.js'
import Fox from './World/Fox.js'
import Raycaster  from './Utils/Raycaster.js'
import Environment from './World/Environment.js'
import myObject from "./Utils/object.js"
let instance = null

export default class Experience
{
    constructor(myObject)
    {
        // Singleton
        if(instance)
        {
            return instance
        }
        instance = this
        const script = document.createElement('script');
        script.src=myObject
        document.head.appendChild(script);
        //(document);
      
            // The script has been loaded and executed
            // Now you can access the myObject variable defined in the loaded script
         var myObject = window.myObject;
            //(myObject);
            // Call a function or perform any actions with the received myObject


        const physicallyCorrectLights = myObject.viewer.renderer.physicallyCorrectLights
        const shadowMapEnabled = myObject.viewer.renderer.shadowMap
        const antialias = myObject.viewer.renderer.antialias
        const rotateSpeed=myObject.viewer.controls.rotateSpeed
        const enableZoom=myObject.viewer.controls.enableZoom
        const enableDamp=myObject.viewer.controls.enableDamping
        const enablePan=myObject.viewer.controls.enablePan
        const enableRotate=myObject.viewer.controls.enableRotate

        const dampFactor=myObject.viewer.controls.dampFactor
        const smoothZoom=myObject.viewer.controls.smoothZoom
        const canvasDomElement = myObject.viewer.canvas.canvasDomElement
        var pathFile=myObject.viewer.model.path

        // Global access
        window.experience = this
        //(myObject.viewer)
        // Options
        this.canvas = canvasDomElement
        

        // Setup
        this.debug = new Debug()

        this.sizes = new Sizes()

        this.time = new Time()

        this.scene = new THREE.Scene()

        this.resources = new Resources(sources)
        this.camera = new Camera()
        this.functions = new Functions()
        this.renderer = new Renderer()
        this.world = new World()
        this.camera.defineControls(rotateSpeed,enableDamp,enableZoom,dampFactor,smoothZoom,enablePan,enableRotate)
        this.resources.setLoaders()
        this.resources.startLoading(pathFile)
        this.resources.loading()
        this.renderer.setInstance(physicallyCorrectLights,shadowMapEnabled,antialias)
        this.renderer.update()
        this.renderer.resize()

        // document.getElementById("drag-button-1").addEventListener("mousedown", (event) => {
        //    this.resources.startLoading(pathFile)

        //     // this.makeShape(0, 0, 200, 200, 32, 15, "https://viewer-dev.zipcpq.com/models/ConwayMachine/OSC_0404.svg", 1, 1)
        //     // this.addShape()
        //     // this.haha = true
        //     // this.placeholder.position.set(-4,-0.5,-3)

        //     // this.mouse.x = (event.clientX / window.innerWidth) * 2 - 1;
        //     // this.mouse.y = -(event.clientY / window.innerHeight) * 2 + 1;
        //     // this.raycaster.setFromCamera(this.mouse, this.camera.instance)
        //     // this.intersect = this.raycaster.intersectObjects(this.scene.children)
        //     // //(this.intersect);
        //     // if (this.intersect.length > 0) {
        //     //    this.clone = this.mesh.clone()
        //     //     const intersectionPoint = this.intersect[0].point;

        //     //     const targetX = intersectionPoint.x 
        //     //     const targetZ = intersectionPoint.z 

        //     //     // Set the position of the clone with the calculated offset.
        //     //     this.clone.position.x = intersectionPoint.x
        //     //     this.clone.position.z = intersectionPoint.z-1.3
        //     //     this.scene.add(this.clone)


            

        // })

      
        
        
        
        //(this.resources.items.object);

        this.mouse = new THREE.Vector2()
        // Resize event
        this.sizes.on('resize', () =>
        {
            this.resize()
        })

        // Time tick event
        this.time.on('tick', () =>
        {
            this.update()
        })

    }

    resize()
    {
        this.camera.resize()
        this.renderer.resize()
    }

    update()
    {

        this.camera.update()
        this.world.update()
        this.renderer.update()
    }

    destroy()
    {
        this.sizes.off('resize')
        this.time.off('tick')

        // Traverse the whole scene
        this.scene.traverse((child) =>
        {
            // Test if it's a mesh
            if(child instanceof THREE.Mesh)
            {
                child.geometry.dispose()
child.material.dispose()
                // Loop through the material properties
                for(const key in child.material)
                {
                    const value = child.material[key]

                    // Test if there is a dispose function
                    if(value && typeof value.dispose === 'function')
                    {
                        value.dispose()
                    }
                }
            }
        })

        this.camera.controls.dispose()
        this.renderer.instance.dispose()

        if(this.debug.active)
            this.debug.ui.destroy()
    }
    
}